var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.amazonLayers
    ? _c("div", [
        _c("div", { staticClass: "row align-center" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "d-flex flex-column" }, [
              _c(
                "h6",
                { staticClass: "font-weight-bold no-wrap align-center" },
                [_vm._v("Amazon Custom Template")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "list-group-item d-inline-flex border-0 px-0 disabled",
                },
                [_c("span", [_vm._v(_vm._s(_setup.amazonHeader.name))])]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-3 mb-3" },
                [
                  _c("span", { staticClass: "mb-2 d-block" }, [
                    _vm._v("Surface"),
                  ]),
                  _vm._v(" "),
                  _setup.surfaces.length > 1
                    ? _c(_setup.CSelect, {
                        staticClass: "flex-fill w-50",
                        attrs: {
                          value: _setup.selectedSurface,
                          options: _setup.surfaces,
                          label: "Select surface",
                          "label-class": "text-bold mb-2",
                        },
                        on: { input: _setup.onSurfaceChange },
                      })
                    : _c("div", { staticClass: "text-muted" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _setup.surfaces[0]?.label || "No surfaces found"
                            ) +
                            "\n                    "
                        ),
                      ]),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-4 align-center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-sm-5" },
            [
              _c(_setup.ModalImportSearch, {
                on: { "search-text-change": _setup.updateSearchText },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mt-2 mb-2" }, [
          _c(
            "div",
            { staticClass: "col-12 layer-tree" },
            [
              _setup.showLoader
                ? _c(
                    "div",
                    {
                      staticClass:
                        "align-items-center d-flex justify-content-center my-2 text-center my-2",
                    },
                    [
                      _c("b-spinner", { attrs: { variant: "primary" } }),
                      _vm._v(" "),
                      _c("strong", { staticClass: "ml-3 primary-text" }, [
                        _vm._v(_vm._s(_setup.loaderMessage)),
                      ]),
                    ],
                    1
                  )
                : [
                    _c(_setup.ModalImportLayersTree, {
                      attrs: { "tree-item": _setup.filteredTreeItems },
                    }),
                    _vm._v(" "),
                    _c("b-pagination", {
                      staticClass: "mt-4",
                      attrs: {
                        "total-rows": _setup.pageElementsCount,
                        "per-page": _setup.perPage,
                        "aria-controls": "my-table",
                        align: "center",
                      },
                      model: {
                        value: _setup.currentPage,
                        callback: function ($$v) {
                          _setup.currentPage = $$v
                        },
                        expression: "currentPage",
                      },
                    }),
                  ],
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mt-4" }, [
          _c("h6", { staticClass: "font-weight-bold" }, [
            _vm._v("Template Info"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-muted small" }, [
            _c("div", [
              _vm._v("Components: " + _vm._s(_setup.templateStats.components)),
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "Canvas Objects: " + _vm._s(_setup.templateStats.canvasObjects)
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v("Bindings: " + _vm._s(_setup.templateStats.bindings)),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-12 col-sm-7" }, [
      _c("h6", { staticClass: "font-weight-bold no-wrap align-center" }, [
        _vm._v("Select elements to import"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }